import React from 'react';
import './AccountDeleted.css';

interface ComponentProps { }

type State = {
	dateFormatted: string
}
export default class AccountDeleted extends React.Component<ComponentProps, State> {

	state: State

	constructor(props: ComponentProps) {
		console.log('AccountDeleted')
		super(props)

		const now = new Date();
		const futureDate = new Date(now.setDate(now.getDate() + 7));
		const formattedFutureDate = new Intl.DateTimeFormat('en-US', {
			year: 'numeric',
			month: 'long',
			day: '2-digit'
		}).format(futureDate);

		this.state = {
			dateFormatted: formattedFutureDate
		}
	}

	render() {
		return (
			<div className="too-many-log-in-container">
				<div className="too-many-log-in-card">
					<form>
						<div className="logos">
							{/* Add your logos here */}
						</div>
						<h1>Account Deleted</h1>
						<div className="message">
							Your account, and all its data, has been successfully deleted.
							<br/>
							You have up to <strong>7 days</strong> to undo this by logging back into your account through either Odience or Verse before
							<strong>{` ${this.state.dateFormatted} `}</strong>
							to reactive it
						</div>
					</form>
				</div>
			</div>
		);
	}
};
